import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { resendCall, resendCode, verify } from 'store/actions';
import { convertApiFormErrors } from '../../helpers';

function useVerification({ id, initToken }){
	const dispatch = useDispatch();

	const [token, setToken] = useState(initToken);
	const [resendSuccess, setResendSuccess] = useState(false);
	const [recallSuccess, setRecallSuccess] = useState(false);

	const [timeLeft, setTimeLeft] = useState(15);

	useEffect(() => {
		if ( !timeLeft ) return;
		const intervalId = setInterval(() => {
			setTimeLeft(timeLeft - 1);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [timeLeft]);

	const handleOnSubmit = async (values) => {
		let apiErrors = {};
		const { code } = values;
		await verify({ code, token, id }, (error) => {
			apiErrors = convertApiFormErrors(error);
		})(dispatch);
		return apiErrors
	};
	const handleResendCode = async () => {
		await resendCode(id, (error) => {
			console.log(error);
		}, (token) => {
			setToken(token);
			setResendSuccess(true);
			setTimeLeft(15);
		});
	};
	const handleResendCall = async () => {
		await resendCall(id, (error) => {
			console.log(error);
		}, (token) => {
			setToken(token);
			setRecallSuccess(true);
			setTimeLeft(15);
		});
	};

	return {
		resendSuccess,
		recallSuccess,
		timeLeft,
		handleOnSubmit,
		handleResendCode,
		handleResendCall
	};
}

export default useVerification;
